module.exports = __webpack_public_path__ + "static/media/wifi-offline.3418c077.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wifi-offline.svg
// module id = 439
// module chunks = 1